module.exports = __webpack_public_path__ + "static/media/user.73bfa9e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/user.svg
// module id = 1716
// module chunks = 0